<template>
  <div>
    <b-row>
      <b-col cols="12" class="pad-5">
        <b-form-group
          :label="$lang.Interview_location_full_path"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.Interview_location_full_path"
            :rules="$v.location_selected.$params"
          />
          <selectAsync
            :options="location_options"
            v-model="$v.location_selected.$model"
            label="caption"
            id="id"
            :asyncFind="getLocation"
            :isValid="
              $v.location_selected.$dirty ? !$v.location_selected.$error : null
            "
            :loading="locationLoading"
            :placeholder="$lang.search_city"
          />

          <b-form-invalid-feedback
            :style="{ display: $v.location_selected.$error ? 'block' : 'none' }"
            id="gender_id-feedback"
          >
            {{ $lang.error_required | replace($lang.city_license) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.place_caption"
          label-for="place_caption"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.place_caption"
            :rules="$v.place_caption.$params"
          />
          <b-form-input
            id="place_caption"
            type="text"
            :autocomplete="$lang.place_caption"
            v-model="$v.place_caption.$model"
            :state="$v.place_caption.$dirty ? !$v.place_caption.$error : null"
          >
          </b-form-input>
          <b-form-invalid-feedback id="place_caption-feedback"
            >{{ $lang.error_required | replace($lang.place_caption) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.place_address"
          label-for="place_address"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.place_address"
            :rules="$v.place_address.$params"
          />
          <b-form-input
            id="place_address"
            type="text"
            autocomplete="off"
            v-model="$v.place_address.$model"
            :state="$v.place_address.$dirty ? !$v.place_address.$error : null"
          >
          </b-form-input>

          <b-form-invalid-feedback id="place_address-feedback">
            {{ $lang.error_required | replace($lang.place_address) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.description"
          label-for="description"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.description"
            :rules="$v.description.$params"
          />
          <Editor dir="rtl" v-model="description">
            <br />
          </Editor>

          <b-form-invalid-feedback id="description-feedback">
            {{ $lang.error_required | replace($lang.description) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" class="mb-3"
        >اتاق‌ها
        <b-button @click="addRoom" size="sm" text="Button" variant="info"
          >+</b-button
        >
      </b-col>
      <b-col
        cols="12"
        v-for="(room, index) in $v.rooms.$each.$iter"
        :key="index"
      >
        <b-row>
          <b-col cols="12" md="5">
            <b-form-group
              :label="$lang.Interview_location_room"
              label-for="caption"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.Interview_location_room"
                :rules="room.room_number.$params"
              />
              <b-form-input
                id="caption"
                type="text"
                :autocomplete="$lang.Interview_location_room"
                v-model="room.room_number.$model"
                :state="
                  room.room_number.$dirty ? !room.room_number.$error : null
                "
              >
              </b-form-input>
              <b-form-invalid-feedback id="caption-feedback">
                {{
                  $lang.error_required | replace($lang.Interview_location_room)
                }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="5">
            <b-form-group
              :label="$lang.Interview_location_room_name"
              label-for="caption"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.Interview_location_room_name"
                :rules="room.room_name.$params"
              />
              <b-form-input
                id="caption"
                type="text"
                :autocomplete="$lang.Interview_location_room_name"
                v-model="room.room_name.$model"
                :state="room.room_name.$dirty ? !room.room_name.$error : null"
              >
              </b-form-input>
              <b-form-invalid-feedback id="caption-feedback">
                {{
                  $lang.error_required
                    | replace($lang.Interview_location_room_name)
                }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="2">
            <label for=""></label><br />
            <b-button
              @click="removeRoom"
              size="md"
              text="Button"
              variant="danger"
              class="mt-3"
              >x</b-button
            >
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="12" class="float-right">
        <div slot="footer" class="form-group form-btn">
          <!-- v-if="permissionBtn" -->
          <!-- permissions.includes(`admin`) || permissions.includes(`edit`) -->
          <b-button @click="submit" type="submit" size="md" variant="success">
            <i class="fa fa-check"></i>
            {{ $lang.submitButton }}
          </b-button>
          <b-button
            type="reset"
            class="ml-2"
            size="md"
            variant="danger"
            @click="cancel"
          >
            <i class="fa fa-ban"></i>
            {{ $lang.cancelButton }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import Editor from "@/components/ckeditor/editor";

export default {
  components: {
    Editor,
  },
  validations: {
    place_address: {},
    description: {},
    place_caption: {
      required,
    },
    location_selected: {
      required,
    },
    Interview_location_room: {},
    rooms: {
      $each: {
        room_number: {
          requiredIf: requiredIf(function (value) {
            if (this.rooms.length == 1) {
              return true;
            }
            if (this.rooms.length > 1) {
              return false;
            }
          }),
        },
        room_name: {},
      },
    },
  },
  props: {
    item: {
      type: Object,
      defualt: () => {},
    },
    permissions: {
      type: Array,
      defualt: () => [],
    },
    mode: {
      type: String,
      defualt: "",
    },
  },
  data() {
    return {
      place_address: null,
      place_caption: null,
      description: null,
      location_selected: null,
      Interview_location_room: null,
      rooms: [
        {
          room_number: null,
          room_name: null,
        },
      ],
      location_options: [],
      locationLoading: false,
    };
  },
  methods: {
    pathOr,
    removeRoom(room) {
      let index = this.rooms.indexOf(room);
      this.rooms.splice(index, 1);
    },

    addRoom() {
      this.rooms.push({
        room_number: null,
        room_name: null,
      });
    },
    async getLocation(query) {
      if (!query || query.length < 2) {
        this.place_birth_options = [];
        return;
      }
      try {
        let url =
          this.$config.api_url +
          this.$config.resources.location +
          `?city=${query}`;
        const response = await this.$httpService.get(url);
        let locations = response.data.data;
        this.location_options = locations;
      } catch (error) {
        this.$generateError(error);
        this.location_options = [];
      }
    },

    cancel() {
      this.$emit("cancel", false);
      this.$emit("closeModal", false);
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      let payload = {
        location_id: pathOr(null, ["id"], this.location_selected),
        place_caption: this.place_caption,
        place_address: this.place_address,
        description: this.description,
        room: this.rooms,
      };

      this.$emit("submit", payload);
    },
    async fetchData() {
      if (this.item && Object.keys(this.item).length > 0) {
        this.location_selected = {
          caption: this.item.location.full_path,
          id: this.item.location.id,
        };
        this.place_address = this.item.place_address;
        this.description = this.item.description;
        this.place_caption = this.item.place_caption;
        this.rooms = JSON.parse(this.item.room);
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

